import React from "react";
import { Card } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import PhoneNumber from "@/model/interface/PhoneNumber";

interface CallerIDSelectorProps {
  phoneNumbers: PhoneNumber[] | undefined;
  selectedCallerId: string;
  onCallerIdChange: (value: string) => void;
}

export default function CallerIDSelector({
  phoneNumbers,
  selectedCallerId,
  onCallerIdChange,
}: CallerIDSelectorProps) {
  return (
    <Card className="p-4">
      <div className="space-y-2">
        <label className="text-sm font-medium dark:text-white">Caller ID</label>
        <Select value={selectedCallerId} onValueChange={onCallerIdChange}>
          <SelectTrigger className="w-full">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {phoneNumbers && phoneNumbers.length > 0 ? (
              phoneNumbers.map((phone: PhoneNumber) => (
                <SelectItem key={phone.id} value={phone.id!!}>
                  {phone.number}
                </SelectItem>
              ))
            ) : (
              <SelectItem value="none" disabled>
                No phone numbers available
              </SelectItem>
            )}
          </SelectContent>
        </Select>
      </div>
    </Card>
  );
}
